import type { QuestionActor } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class AbTestingApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { id, answersActors } = actor.getSnapshot().context;

        return {
            question: id,
            data: answersActors.map((answersActor) => {
                const { id, response: responseActor } = answersActor.getSnapshot().context;
                const response = responseActor.getSnapshot().context;
                const value = id === response.value || Boolean(response.value);
                return {
                    answer: id,
                    bool: value,
                };
            }),
            comment: undefined,
        };
    }
}
